
import { NextFunction, Request, Response } from 'express';

export async function ensureIsAuthenticated(
  request: Request,
  response: Response,
  next: NextFunction,
) {
  try {
    const authHeader = request.headers.authorization;

    if (!authHeader) {
      return response.status(401).json({
        message: 'Token is missing!.'
      }).send()
    }
  
    const [, token] = authHeader.split(' ');

    const check = token === process.env.HASH

    if (!check) {
      return response.status(401).json({
        message: 'Token is invalid!.'
      }).send()
    }

    next();
  } catch (error) {
    return response.status(401).json({
      message: 'Token is invalid!.'
    }).send()
  }
}